import React from 'react';
import Translate from 'react-translate-component';
import { Button, Col, Row } from 'antd';

import ErrorHTML from 'components/common/form/ErrorHTML';

const ItemModalFooter = ({ meta, handleSubmit }) => {
    return (
        <Row>
            <Col xs={{ span: 12 }} className="alert-inline">
                <ErrorHTML meta={meta} />
            </Col>
            <Col xs={{ span: 12 }}>
                <Button type='blue' onClick={handleSubmit} disabled={meta.pending}>
                    <Translate content='modal_settings.save' />
                </Button>
            </Col>
        </Row>
    );
};

export default ItemModalFooter;
